import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetContact } from '../AppActionTypes';

export interface SetContactAction extends Action {
  item: IContentInfo;
}

export function setContactAction(item: IContentInfo): SetContactAction {
  return {
    type: SetContact,
    item
  };
}
